export default __webpack_public_path__ + "static/media/project.007d64ec.jpg";